/**
 * The two things `AppShell` needs to know about the BROWSER before it renders:
 * whether the operator has collapsed the sidebar before, and whether this is a
 * mobile viewport.
 *
 * Hoisted out of `AppShell.tsx` when it crossed the ~300-line ceiling
 * (`.claude/rules/architecture.md`). A genuine leaf rather than a line-count
 * trim: both are pure reads of `window` with no React and nothing imported back
 * from the shell, and both are guarded for a `window`-less render because the
 * shell's initial state is computed during the first render pass.
 */

const COLLAPSE_STORAGE_KEY = 'syncanix:sidebar:collapsed';

/** Below this width the shell swaps the rail for the mobile drawer. */
export const MOBILE_BREAKPOINT = 768;

/** The collapsed state the operator last chose, defaulting to expanded. */
export function readInitialCollapsed(): boolean {
  if (typeof window === 'undefined') return false;
  return window.localStorage.getItem(COLLAPSE_STORAGE_KEY) === 'true';
}

/** Persist the operator's choice so the next page load opens the same way. */
export function writeCollapsed(collapsed: boolean): void {
  if (typeof window === 'undefined') return;
  window.localStorage.setItem(COLLAPSE_STORAGE_KEY, String(collapsed));
}

export function isMobileViewport(): boolean {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return false;
  return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT - 1}px)`).matches;
}
